import { Injectable} from '@angular/core';


import Shepherd from 'shepherd.js';
import { GlobalVariables } from 'src/app/data/global-variables';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class TourService {

  private subject = new Subject();

  // Observable que se puede suscribir en el componente
  observable$ = this.subject.asObservable();

  guideTour = new Shepherd.Tour();

  tourMode = "none";

  constructor(
    public globalVariables: GlobalVariables,
  ) { }

  setTourMode(type: string) {
    if (type) {
      this.tourMode = type;
    }
  }

  initDesktopTour(): void {

    console.log("Inicializando tour escritorio");

    this.guideTour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        classes: 'custom-class',
        scrollTo: true,
        cancelIcon: {
          enabled: false
        },
        canClickTarget: false,
        /*when: {
          show() {
            if (Shepherd.activeTour != undefined) {
              const currentStep = Shepherd.activeTour?.getCurrentStep();
              if (currentStep != null) {
                const currentStepElement = currentStep?.getElement();
                if (currentStepElement != null) {


                  currentStepElement.style['margin-left'] = '30px';
                  currentStepElement.style['margin-top'] = '10px';

                  const header = currentStepElement?.querySelector('.shepherd-header');
                  const progress = document.createElement('span');
                  progress.style['margin-right'] = '200px';
                  progress.style['color'] = '#FFFFFF';
                  progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                  header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));

                  // Ocultar el icono de cancelación
                  const cancelIcon = currentStepElement.querySelector('.shepherd-cancel-icon');
                  if (cancelIcon) {
                    cancelIcon.remove();
                  }
                }
              }
            }
          }
        }*/
      }

    });

  }



  initMobileTour(): void {
    console.log("Inicializando tour movil");

    this.guideTour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        classes: 'newShepherdStyle',
        scrollTo: true,
        cancelIcon: {
          enabled: false
        },
        canClickTarget: false,
        /*when: {
          show() {
            if (Shepherd.activeTour != undefined) {
              const currentStep = Shepherd.activeTour?.getCurrentStep();
              if (currentStep != null) {
                const currentStepElement = currentStep?.getElement();
                if (currentStepElement != null) {

                  currentStepElement.style['margin-top'] = '20px';

                  const header = currentStepElement?.querySelector('.shepherd-header');
                  const progress = document.createElement('span');
                  progress.style['margin-right'] = '200px';
                  progress.style['color'] = '#FFFFFF';
                  progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                  header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));

                  // Ocultar el icono de cancelación
                  const cancelIcon = currentStepElement.querySelector('.shepherd-cancel-icon');
                  if (cancelIcon) {
                    cancelIcon.remove();
                  }
                }
              }
            }
          }
        }*/
      }

    });
  }




  createTourVisorCookie() {

    this.guideTour.addSteps([

      {
        id: "btn-0",
        attachTo: {
          element: "#top-banner > button.btn.btn-tour",
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "De acuerdo!",
            action: this.guideTour.complete
          }
        ],
        classes: "shepherd-text tour-container",
        text: "Pulsa aquí si necesitas acceder a una guía de uso de la herramienta",
        modalOverlayOpeningPadding: 15,
      }
    ]);

  }

  createTourVisorMobileCookie() {

    this.guideTour.addSteps([

      {
        id: "btn-0",
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Listo",
            action: this.guideTour.complete
          }
        ],
        classes: "shepherd-text tour-container",
        text: "",
        when: {
          show() {
            if (Shepherd.activeTour != undefined) {
              const currentStep = Shepherd.activeTour?.getCurrentStep();
              if (currentStep != null) {
                const currentStepElement = currentStep?.getElement();
                if (currentStepElement != null) {


                  //------------- AQUI METO LAS IMAGENES -------------------------
                  // Crear el contenedor principal
                  const gridContainer = document.createElement('div');
                  gridContainer.classList.add('grid-container');

                  // Array de datos para las imágenes y los textos
                  const imageData = [
                    { src: '../assets/img/intensidades.png', text: 'Ventanado' },
                    { src: '../assets/img/despla.png', text: 'Mover imagen' },
                    { src: '../assets/img/zoom.png', text: 'Imagen <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Ampliar/Desampliar' },
                    { src: '../assets/img/zoom.png', text: 'Serie <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Cambiar de imagen' }
                  ];

                  // Recorrer los datos y crear los elementos correspondientes
                  imageData.forEach(data => {
                    // Crear el div para cada item de la cuadrícula
                    const gridItem = document.createElement('div');
                    gridItem.classList.add('grid-item');

                    // Crear la imagen
                    const image = document.createElement('img');
                    image.src = data.src;
                    image.alt = 'Imagen';

                    // Crear el párrafo para el texto
                    const paragraph = document.createElement('p');
                    paragraph.innerText = data.text;

                    // Agregar la imagen y el párrafo al div del item
                    gridItem.appendChild(image);
                    gridItem.appendChild(paragraph);

                    // Agregar el item al contenedor principal
                    gridContainer.appendChild(gridItem);
                  });


                  const insertionPoint = document.getElementById('btn-0-description');
                  insertionPoint?.insertBefore(gridContainer, insertionPoint.querySelector('.shepherd-text'));


                  //--------------------
                }
              }
            }
          }
        }

      }
    ]);

  }


  createTourVisor(): Promise<void> {

    return new Promise(resolve => {

      this.guideTour.addSteps([
        {
          id: "btn-1",
          attachTo: {
            element: "#visor-container > div.h-100.w-100 > div > div",
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-container",
          highlightClass: "",
          title: "",
          text: "Este es el visor. En él podemos manipular las diferentes imágenes del estudio",
          when: {
            show() {
              if (Shepherd.activeTour != undefined) {
                const currentStep = Shepherd.activeTour?.getCurrentStep();
                if (currentStep != null) {
                  const currentStepElement = currentStep?.getElement();
                  if (currentStepElement != null) {

                    //------------- AQUI METO LA CABECERA -------------------------
                    currentStepElement.style['margin-left'] = '30px';
                    currentStepElement.style['margin-top'] = '30px';

                    const header = currentStepElement?.querySelector('.shepherd-header');
                    const progress = document.createElement('span');
                    progress.style['margin-right'] = '100px';
                    progress.style['color'] = '#FFFFFF';
                    progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                    header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));


                    //------------- AQUI METO LAS IMAGENES -------------------------
                    // Crear el contenedor principal
                    const gridContainer = document.createElement('div');
                    gridContainer.classList.add('grid-container');

                    // Array de datos para las imágenes y los textos
                    const imageData = [
                      { src: 'assets/img/intensidades.png', text: 'Ventanado' },
                      { src: 'assets/img/despla.png', text: 'Mover imagen' },
                      { src: 'assets/img/zoom.png', text: 'Imagen: Ampliar/Desampliar' },
                      { src: 'assets/img/zoom.png', text: 'Serie: Cambiar de imagen' }
                    ];

                    // Recorrer los datos y crear los elementos correspondientes
                    imageData.forEach(data => {
                      // Crear el div para cada item de la cuadrícula
                      const gridItem = document.createElement('div');
                      gridItem.classList.add('grid-item');

                      // Crear la imagen
                      const image = document.createElement('img');
                      image.src = data.src;
                      image.alt = 'Imagen';

                      // Crear el párrafo para el texto
                      const paragraph = document.createElement('p');
                      paragraph.innerText = data.text;

                      // Agregar la imagen y el párrafo al div del item
                      gridItem.appendChild(image);
                      gridItem.appendChild(paragraph);

                      // Agregar el item al contenedor principal
                      gridContainer.appendChild(gridItem);
                    });


                    const insertionPoint = document.getElementById('btn-1-description');
                    insertionPoint?.insertBefore(gridContainer, insertionPoint.querySelector('.shepherd-text'));


                    //--------------------
                  }
                }
              }
            }
          }
        },
        {
          id: "btn-4",
          attachTo: {
            element: "#top-banner",
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
              }

            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();
                this.subject.next(1);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          highlightClass: "",
          title: "",
          text: "Este es el menú con las herramientas",

        },
        {
          id: "btn-5",
          attachTo: {
            element: '#top-banner > div:nth-child(3) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(1);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();
                this.subject.next(2);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          highlightClass: "",
          title: "",
          text: "Ajustes de la imagen",

        },
        {
          id: "btn-6",
          attachTo: {
            element: '#top-banner > div:nth-child(4) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(1);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next()
                this.subject.next(3);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          highlightClass: "",
          title: "",
          text: "Trasformación de la imagen",
        },
        {
          id: "btn-7",
          attachTo: {
            element: '#top-banner > div:nth-child(5) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(2);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next()
                this.subject.next(4);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          highlightClass: "",
          title: "",
          text: "Opciones básicas",
        },
        {
          id: "btn-8",
          attachTo: {
            element: '#top-banner > div:nth-child(6) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(3);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();
                this.subject.next(10);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          highlightClass: "",
          title: "",
          text: "Herramientas DICOM de anotación",
        },
        {
          id: "btn-9",
          attachTo: {
            element: '#top-banner > div.my-btn-group.collapsable-tool-btn-container.ms-2 > div > span',
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(4);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Finalizar",
              action: this.guideTour.complete
            }
          ],
          classes: "shepherd-text tour-container",

          highlightClass: "",
          title: "",
          text: "Pulsando este botón devolverás la imagen a su estado original",
          modalOverlayOpeningPadding: 5
        }
      ])
      resolve()
    });
  }

  deleteAllSteps(steps: number): Promise<void> {

    return new Promise(resolve => {

      if (this.guideTour.steps) {
        for (let i = 0; i < steps; i++) {
          //this.guideTour.steps.forEach(step => this.guideTour.removeStep(step.id));
          this.guideTour.removeStep("btn-" + i);
        }
      }
      resolve()
    });
  }

  /*showDesktopHelp() {

    const promises: Promise<any>[] = [];
    promises.push(this.deleteAllSteps());
    //promises.push(this.createBasicTour2());
    promises.push(this.anotherNewTour());
    Promise.all(promises)
      .then(() => {
        console.error(this.guideTour.steps.length);
        ($("#flipbook") as any).turn("page", 1);
        this.subject.next(53);
        this.guideTour.start();
      })
  }*/


  /*showMobilepHelp() {

    const promises: Promise<any>[] = [];
    promises.push(this.deleteAllSteps());
    promises.push(this.createBasicTourMobile2());
    Promise.all(promises)
      .then(() => { ($('.carousel') as any).carousel(0); this.guideTour.start(); })

  }*/

  /*showMobileLandscapeHelp() {

    const promises: Promise<any>[] = [];
    promises.push(this.deleteAllSteps());
    promises.push(this.createBasicTourMobileLandsCape2());
    Promise.all(promises)
      .then(() => { ($('.carousel') as any).carousel(0); this.guideTour.start(); })

  }*/

  /*showVisorHelp() {

    const promises: Promise<any>[] = [];
    promises.push(this.deleteAllSteps());
    promises.push(this.createTourVisor());
    Promise.all(promises)
      .then(() => { this.guideTour.start(); })

  }*/

  checkTurn(currentPage: number) {

    if (currentPage == 2 && this.guideTour.getCurrentStep()?.id != 'btn-11') {
      this.guideTour.next();
    } /*else if (currentPage == 1 && this.guideTour.getCurrentStep()?.id == 'btn-2') {
      this.guideTour.back();
    }*/
  }

  /*checkVisorClose(closed: boolean) {
    if (closed) {
      if (this.guideTour.isActive() && this.guideTour.getCurrentStep()?.id == 'btn-10') {
        this.guideTour.show("btn-11", true)
        this.subject.next(52);
      }
    }
  }*/

  /*checkTourStep(step: string) {
    if (this.guideTour.getCurrentStep()?.id == step) {
      return true;
    }else{
      return false;
    }

  }*/

 


  //-- NUEVA VERSION AUTOMÁTICA DE ESCRITORIO-------------
  /*anotherNewTour() {

    return new Promise(resolve => {

      this.guideTour.addSteps([
        {
          id: "btn-1",
          attachTo: {
            element: ".report-container",
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.subject.next(50);
                //($("#flipbook") as any).turn("disable", false);
                ($("#flipbook") as any).turn("page", 1);
                this.deleteAllSteps();

                this.subject.next(52);
                this.guideTour.complete();

              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                //($("#flipbook") as any).turn("disable", false);
                ($("#flipbook") as any).turn("page", 2);
                this.subject.next(60);
                this.subject.next(51);
                //his.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text:
            '<p>Bienvenido, este es tu Book digital. En el se encuentra tu informe e imágenes del estudio.</p>' +
            '<p>Pulsando en las esquinas o arrastrando con el ratón, podrás abrir el libro como si fuese uno de papel</p>'
        },
        {
          id: "btn-2",
          attachTo: {

            element: "#bookRow",
            on: "top"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(61);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.guideTour.back();
                this.subject.next(61);
              }

            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.subject.next(61);
                this.subject.next(5);
                this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-container",
          canClickTarget: false,
          text: "</p>Dentro del Book, podemos visualizar:</p>" +
            '<p>A la izquierda <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> El informe resultante del estudio</p>' +
            '<p>A la derecha <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Las imágenes del estudio. Puedes navegar por el libro y acceder a cada imagen individualmente pulsando sobre ella</p>'
        },
        {
          id: "btn-3",
          attachTo: {
            //element: "#visor-container > div.h-100.w-100 > div > div > canvas",
            element: "#visor-container > div.h-100.w-100 > div > div",
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.subject.next(8);
                this.deleteAllSteps();
                this.guideTour.complete();

              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.subject.next(60);
                this.guideTour.back();
                this.subject.next(6);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                //this.subject.next(5);
                this.subject.next(8);
                this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Este es el visor. En el podemos manipular las diferentes imágenes del estudio",
          canClickTarget: true,
          when: {
            show() {
              if (Shepherd.activeTour != undefined) {
                const currentStep = Shepherd.activeTour?.getCurrentStep();
                if (currentStep != null) {
                  const currentStepElement = currentStep?.getElement();
                  if (currentStepElement != null) {

                    //------------- AQUI METO LA CABECERA -------------------------
                    currentStepElement.style['margin-left'] = '30px';
                    currentStepElement.style['margin-top'] = '30px';

                    const header = currentStepElement?.querySelector('.shepherd-header');
                    const progress = document.createElement('span');
                    progress.style['margin-right'] = '100px';
                    progress.style['color'] = '#FFFFFF';
                    progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                    header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));


                    //------------- AQUI METO LAS IMAGENES -------------------------
                    // Crear el contenedor principal
                    const gridContainer = document.createElement('div');
                    gridContainer.classList.add('grid-container');
                    currentStepElement.querySelector("#visor-container > div.h-100.w-100 > div > div")?.classList.add("custom-highlight");

                    // Array de datos para las imágenes y los textos
                    const imageData = [
                      { src: 'assets/img/intensidades.png', text: 'Ventanado' },
                      { src: 'assets/img/despla.png', text: 'Mover imagen' },
                      { src: 'assets/img/zoom.png', text: 'Imagen: Ampliar/Desampliar' },
                      { src: 'assets/img/zoom.png', text: 'Serie: Cambiar de imagen' }
                    ];

                    // Recorrer los datos y crear los elementos correspondientes
                    imageData.forEach(data => {
                      // Crear el div para cada item de la cuadrícula
                      const gridItem = document.createElement('div');
                      gridItem.classList.add('grid-item');

                      // Crear la imagen
                      const image = document.createElement('img');
                      image.src = data.src;
                      image.alt = 'Imagen';

                      // Crear el párrafo para el texto
                      const paragraph = document.createElement('p');
                      paragraph.innerText = data.text;

                      // Agregar la imagen y el párrafo al div del item
                      gridItem.appendChild(image);
                      gridItem.appendChild(paragraph);

                      // Agregar el item al contenedor principal
                      gridContainer.appendChild(gridItem);
                    });


                    const insertionPoint = document.getElementById('btn-3-description');
                    insertionPoint?.insertBefore(gridContainer, insertionPoint.querySelector('.shepherd-text'));

                    // AQUI ELIMINO LA X DE PARA CERRAR LA VENTANA
                    const cancelIcon = currentStepElement.querySelector('.shepherd-cancel-icon');
                    if (cancelIcon) {
                      cancelIcon.remove();
                    }

                    //--------------------
                  }
                }
              }
            }
          }
        },
        {
          id: "btn-4",
          attachTo: {
            element: "#top-banner",
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.subject.next(7);
                this.guideTour.back();
              }

            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();
                this.subject.next(1);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Este es el menú con las herramientas",
          canClickTarget: false,

        },
        {
          id: "btn-5",
          attachTo: {
            element: '#top-banner > div:nth-child(2) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(1);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();
                this.subject.next(2);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Ajustes de la imagen",
          canClickTarget: false,

        },
        {
          id: "btn-6",
          attachTo: {
            element: '#top-banner > div:nth-child(3) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(1);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next()
                this.subject.next(3);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Trasformación de la imagen",
          canClickTarget: false,
        },
        {
          id: "btn-7",
          attachTo: {
            element: '#top-banner > div:nth-child(4) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(2);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next()
                this.subject.next(4);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Opciones básicas",
          canClickTarget: false,
        },
        {
          id: "btn-8",
          attachTo: {
            element: '#top-banner > div:nth-child(5) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(3);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();
                this.subject.next(10);
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Herramientas DICOM de anotación",
          canClickTarget: false,
        },
        {
          id: "btn-9",
          attachTo: {
            element: '#top-banner > div.my-btn-group.collapsable-tool-btn-container.ms-2 > div > span',
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
                this.subject.next(4);
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                //this.subject.next(6);
                this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Pulsando este botón devolverás la imagen a su estado original",
          canClickTarget: false,
          modalOverlayOpeningPadding: 5
        },
        {
          id: "btn-10",
          attachTo: {
            //element: "#top-banner > button.btn.btn-close.p-0.px-3.ng-star-inserted",
            element: "#visor-container > div.h-100.w-100 > div > div",
            on: "right-start"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.subject.next(52);
                this.subject.next(6);
                this.deleteAllSteps();
                this.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.subject.next(6);
                this.subject.next(52);
                ($("#flipbook") as any).turn("page", 1);

                
                //this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Interactua con el visor o pulsa \"Siguiente\" para seguir con el tour",

        },
        
        {
          id: "btn-11",
          attachTo: {
            element: '#book-digital-container > app-book-pdf-flipbook-landscape > app-side-options-desktop > div > div > div.btns-tour',
            on: "right"

          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                ($("#flipbook") as any).turn("page", 2);
                this.subject.next(5);
                this.subject.next(51);
                this.subject.next(8);

                this.guideTour.back();

              }
            },
            {
              classes: 'tour-round-button',
              text: "Finalizar",
              action: () => {
                this.subject.next(52);
                this.guideTour.complete();

              }
            }
          ],
          classes: "shepherd-text tour-container",
          modalOverlayOpeningPadding: 15,
          canClickTarget: false,
          text: "<p>Estas son las opciones de mayor utilidad para el usuario:</p>" +
            '<p>Descargar DICOM <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Descarga el estudio en formato médico para abrirlo en otros visores</p>' +
            '<p>Ver estudio <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Abre un visor de imágenes DICOM en una ventana externa</p>' +
            '<p>Compartir <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#e8eaed" style="margin-bottom:1px;"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg> Permite compartir el Book añadiendo una dirección de correo electrónico</p>'
        }
      ])
      resolve(true);
    });

  }*/


  //---------- NUEVA VERSION AUTOMÁTICA DE MOVIL VERTICAL -------------

  newBasicTourMobile2(): Promise<void> {

    return new Promise(resolve => {

      this.guideTour.addSteps([

        {
          id: "btn-1",
          attachTo: {
            element: "#book-container > div",
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(0, 0);
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(1, 0);
                this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-mobile-container-vertical",
          canClickTarget: false,
          text: "<p>Esta es la portada de tu Book digital</p>" +
            "<p>Podrás deslizar para pasar a la siguiente página</p>",
          title: "",
        },
        {
          id: "btn-2",
          attachTo: {
            element: "#book-container > div",
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(0, 0);
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(0, 0);
                this.guideTour.back();
              }

            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(2, 0);
                this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-mobile-container-vertical",
          canClickTarget: false,
          text: "<p>En la primera página tenemos el informe resultante del estudio<p>",
          title: "",

        },
        {
          id: "btn-3",
          attachTo: {
            element: '#book-container > div ',
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(0, 0);
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(1, 0);
                this.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                //($('.carousel') as any).carousel(3)
                //this.subject.next(70)
                this.guideTour.next();

              }
            }
          ],
          classes: "shepherd-text tour-mobile-container-vertical",
          canClickTarget: false,
          text: "<p>En las siguiente páginas tendrás las imágenes del estudio.</p>" +
            "<p>Podrás pulsarlas para ampliarlas</p>",
          title: "",

        },
        /*{
          id: "btn-4",
          attachTo: {
            element: '#book-container > div ',
            on: "top"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($('.carousel') as any).carousel(0)
                this.subject.next(6)
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                ($('.carousel') as any).carousel(2)
                this.subject.next(6)
                this.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                ($('.carousel') as any).carousel(0)
                this.subject.next(6);
                // Esto es porque a veces no se ejecutaba
                setTimeout(() => {
                  ($('.carousel') as any).carousel(0)
                }, 10);
                this.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-mobile-container-vertical",
          canClickTarget: false,
          text: "Este es el visor. En él podemos manipular las diferentes imágenes del estudio",
          title: "",

        },*/
        {
          id: "btn-5",
          attachTo: {
            element: "#book-digital-container > app-book-pdf-flipbook-vertical > div > div.share-icon-container.right.clickable",
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(0, 0);
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                //this.subject.next(70)
                this.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.guideTour.next();

              }
            }
          ],
          classes: "shepherd-text tour-mobile-container-vertical",
          modalOverlayOpeningPadding: 10,
          canClickTarget: false,
          text: "<p>Pulsando ese botón se puede descargar el informe en formato pdf</p>",
          title: "",

        },
        {
          id: "btn-6",
          attachTo: {
            element: "#book-digital-container > app-book-pdf-flipbook-vertical > div > div.share-icon-container.left.clickable",
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: this.guideTour.back,
            },
            {
              classes: 'tour-round-button',
              text: "Finalizar",
              action: () => {
                (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(0, 0);
                this.guideTour.complete();
              }
            }
          ],
          classes: "shepherd-text tour-mobile-container-vertical",
          modalOverlayOpeningPadding: 10,
          text: "<p>Pulsando ese botón podrás compartir el Book añadiendo una dirección de correo electrónico</p>",
          canClickTarget: false,
          title: "",

        }
      ])
      resolve()
    });
  }

  //-- NUEVA VERSION AUTOMÁTICA DE MOVIL LANDSCAPE -------------

  /*newTourMobileLandsCape2(): Promise<void> {

    return new Promise(resolve => {
      this.guideTour.addSteps([

        {
          id: "btn-1",
          attachTo: {
            element: "#flipbook > div:nth-child(8)",
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.deleteAllSteps();
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                ($("#flipbook") as any).turn("page", 2);
                //this.guideTour.next();

              }
            }
          ],
          classes: "shepherd-text tour-mobile-landscape-container2",
          text:
            '<p>Bienvenido, este es tu Book digital.</p>' +
            '<p>Pulsando en las esquinas o arrastrando, podrás abrir el libro como si fuese uno de papel</p>',
          title: "",
          //when: {
            show() {
              if (Shepherd.activeTour != undefined) {
                const currentStep = Shepherd.activeTour?.getCurrentStep();
                if (currentStep != null) {
                  const currentStepElement = currentStep?.getElement();
                  if (currentStepElement != null) {

                    const header = currentStepElement?.querySelector('.shepherd-header');
                    const progress = document.createElement('span');
                    progress.style['margin-right'] = '100px';
                    progress.style['color'] = '#FFFFFF';
                    progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                    header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));
                  }
                }
              }
            }
          }//

        },
        {
          id: "btn-2",
          attachTo: {
            element: "#flipbook",
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button tour-btn-list',
              text: "Omitir",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.deleteAllSteps();
                this.guideTour.cancel();
              }
            },
            {
              classes: 'tour-round-button tour-btn-list',
              text: "Atrás",
              action: () => {
                ($("#flipbook") as any).turn("page", 1);
                this.guideTour.back();
              }

            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.subject.next(62);
                //($("#flipbook") as any).turn("page", 1);
                this.guideTour.next();

              }
            }
          ],
          classes: "shepherd-text tour-mobile-landscape-container2",
          text: "<p>Dentro del libro, tienes las diferentes imágenes estudio.</p>" +
            "<p>Podrás pulsarlas para acceder a un visor</p>",
          canClickTarget: false,
          title: "",
          //when: {
            show() {
              if (Shepherd.activeTour != undefined) {
                const currentStep = Shepherd.activeTour?.getCurrentStep();
                if (currentStep != null) {
                  const currentStepElement = currentStep?.getElement();
                  if (currentStepElement != null) {

                    const header = currentStepElement?.querySelector('.shepherd-header');
                    const progress = document.createElement('span');
                    progress.style['margin-right'] = '100px';
                    progress.style['color'] = '#FFFFFF';
                    progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                    header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));
                  }
                }
              }
            }
          }//

        },
        {
          id: "btn-3",
          attachTo: {
            element: '#flipbook',
            //element: '#book-digital-container > app-book-pdf-flipbook-landscape > div:nth-child(2)',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                ($("#flipbook") as any).turn("page", 2);
                this.subject.next(6);
                this.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.subject.next(6);
                ($("#flipbook") as any).turn("page", 1);
                this.guideTour.next();

              }
            }
          ],
          classes: "shepherd-text tour-mobile-landscape-container",
          //modalOverlayOpeningPadding: 2,
          text: "Este es el visor. En él podemos manipular las diferentes imágenes del estudio",
          canClickTarget: true,
        },
        {
          id: "btn-4",
          attachTo: {
            element: '#book-digital-container > app-book-pdf-flipbook-landscape > div:nth-child(2)',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                //($("#flipbook") as any).turn("page", 2);
                this.subject.next(62);
                this.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Finalizar",
              action: () => {
                this.guideTour.complete();

              }
            }
          ],
          classes: "shepherd-text tour-mobile-landscape-container",
          modalOverlayOpeningPadding: 10,
          text: "<p>Pulsando ese botón podrás descargar el informe en formato pdf</p>",
          title: "",

        }

      ])
      resolve()
    });
  }*/


}

